import { useRouter } from 'next/router';

import { QUERY_PARAMS } from 'constants/queryNames';

export const useIsEnabledValidationOnMount = (
  skipValidationQueryName: string = QUERY_PARAMS.IS_SKIP_AUTO_VALIDATION,
) => {
  const router = useRouter();
  const { query } = router;
  const isSkipAutoValidation = query[skipValidationQueryName] as string | undefined;

  return !isSkipAutoValidation;
};
